module.exports = __webpack_public_path__ + "svg/shoulders-slimmer.abb14d5796695085709e77c857d9e438.svg";